import MainComponent from "components/Main";
import PropTypes from 'prop-types';

import Input from "components/Input";

import './index.less';
import './themes/default.less';

export default class InputRangeN extends MainComponent {

    static propTypes = {
        items: PropTypes.array,
        prefix: PropTypes.string,
        currentValue: PropTypes.number,
        onDragOver: PropTypes.func,
        round: PropTypes.bool,
        inputShow: PropTypes.bool,
    };

    static defaultProps = {
        items: [],
        prefix: "",
        currentValue: 0,
        onDragOver: null,
        round: false,
        inputShow: true,
    };

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            left: 0,
            firstClick: false,
            currentValue: 0,
            maxValue: 0,
            minValue: 0,
        };
    }

    set value(value) {
        const left = this.map[value];
        const currentValue = value;
        this.setState({ left, currentValue });
    }

    componentDidMount() {
        this.refresh();
    }

    refresh() {
        const { items, currentValue } = this.props;
        this.arrObj = {};
        const map = {};
        if (this["scale0"]) {
            items.forEach((it, i, arr) => {
                const el = this["scale" + (i + 1)];
                const coord = this._helper.dom.coords(el);
                this.arrObj[it] = coord;
                const start = it;
                const end = arr[i + 1] ? arr[i + 1] : +start + 1;
                const count = end - start;
                const ro = coord.w / count;

                for (let l = 0; l < count; l++) {
                    map[+start + l] = coord.l + (ro * l) - 7;
                }

            });
            this.state.minValue = items[0];
            this.state.maxValue = items[items.length - 1];
        }
        this.map = map;

        this.changeState("left", map[currentValue ? currentValue : 0]);
    }

    getValue(i, event) {
        const { items, round } = this.props;
        const { firstClick } = this.state;
        if (!firstClick) {
            this.state.firstClick = true;
            this.refresh();
        }

        const val = items.length === i ? items[i - 1] : items[i];

        const x = event.clientX - this.arrObj[val].x;
        const v = this.arrObj[val].l - 7 + x;

        if (round) {
            let r = i;
            if (items[i - 1]) {
                const d = this.getValueMap(v);
                const d1 = Math.abs(items[i - 1] - d);
                const d2 = Math.abs(items[i] - d);
                if (d1 < d2)
                    r = i - 1;
            }

            if (i === 0 && Math.abs(v - this.arrObj[items[0]].l) < Math.abs(v - this.arrObj[items[1]].l)) {
                r = 0;
            }

            const resp = (items.length && this.arrObj[items[r]]?.l) ? this.arrObj[items[r]].l - 7 : v;

            return resp;
        }

        return v;
    }


    getValueMap(target) {
        let keyFind = null;
        let min = Infinity;
        for (const key in this.map) {
            const difference = Math.abs(this.map[key] - target);
            if (difference < min) {
                min = difference;
                keyFind = key;
            }
        }
        return keyFind;
    }

    onDragOver(i, event) {
        this._helper.stopEvent(event);
        if (this?.inp)
            this.inp.value = this.getValueMap(this.getValue(i, event));
    }

    onMove(i, event) {
        const left = this.getValue(i, event);
        const currentValue = this.getValueMap(left);
        const { minValue, maxValue } = this.state;
        const clampedValue = Math.min(Math.max(currentValue, minValue), maxValue);
        this.setState({ left: this.map[clampedValue], currentValue: clampedValue });
        if (this.props.onChange.apply)
            this.props.onChange(clampedValue);
    }

    onChange(value) {
        const { maxValue, minValue } = this.state;
        const clampedValue = Math.min(Math.max(value, minValue), maxValue);
        const left = this.map[clampedValue];
        this.setState({ left, currentValue: clampedValue });

        if (this.props.onChange.apply)
            this.props.onChange(clampedValue);
    }

    render() {
        const { left, currentValue } = this.state;
        const { items, prefix, inputShow } = this.props;

        const scale = new Array(items.length + 1).fill();

        return (
            <div className="inputRangeN flex flex1 gap16">
                {inputShow && <div className="inpCont rad4 pos rel text p1">
                    <Input
                        ref={el => this.inp = el}
                        type="number"
                        value={currentValue}
                        onChange={this.onChange.bind(this)}
                    />
                </div>}
                <div className="contRange flex1">
                    <div className="inputRangeN flex col gap8 w100">
                        <div className="scale flex flex1 pos rel hand">
                            {scale.map((_, i) => (<div
                                key={"sc" + i}
                                ref={el => this["scale" + i] = el}
                                className="scaleItem pos rel"
                                onDragOver={this.onDragOver.bind(this, i)}
                                onDrop={this.onMove.bind(this, i)}>
                                <div
                                    className="pos abs w100 hand"
                                    onClick={this.onMove.bind(this, i)} />
                            </div>))}
                            <div
                                className="slider pos abs transit025"
                                draggable={true}
                                style={{ "--left": `${left}px` }} />
                        </div>
                        <div className="legend flex flex1 text p2">
                            {items.map((it, i) => (<div key={"leg" + i} className={`flex1 flex centerH ${+currentValue === +it ? "active" : ""}`}>
                                {it + prefix}
                            </div>))}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
